
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { CreditCard, AlertTriangle, CheckCircle } from 'lucide-react';

interface CreditBlockProps {
  balance: number;
  isMember: boolean;
  creditsNeeded: number;
  creditsSufficient: boolean;
}

const CreditBlock = ({ balance, isMember, creditsNeeded, creditsSufficient }: CreditBlockProps) => {
  return (
    <Card className="border-juv-rose-clay/20 bg-white">
      <CardHeader>
        <CardTitle className="flex items-center space-x-2 text-juv-deep-chestnut">
          <CreditCard className="h-5 w-5" />
          <span>Credit Balance</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <span className="text-juv-deep-chestnut/70">Available Credits:</span>
            <span className="text-2xl font-bold text-juv-terracotta">{balance}</span>
          </div>
          
          {creditsNeeded > 0 && (
            <div className="flex items-center justify-between">
              <span className="text-juv-deep-chestnut/70">Credits Needed:</span>
              <span className="text-lg font-semibold text-juv-deep-chestnut">{creditsNeeded}</span>
            </div>
          )}
          
          <div className="flex items-center space-x-2">
            {creditsSufficient ? (
              <>
                <CheckCircle className="h-4 w-4 text-green-600" />
                <Badge className="bg-green-100 text-green-700">Sufficient Credits</Badge>
              </>
            ) : (
              <>
                <AlertTriangle className="h-4 w-4 text-orange-600" />
                <Badge variant="outline" className="text-orange-700 border-orange-200">
                  Need {creditsNeeded - balance} more credits
                </Badge>
              </>
            )}
          </div>
          
          {isMember && (
            <Badge className="bg-juv-terracotta text-white">
              JUV Member - Exclusive Pricing
            </Badge>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default CreditBlock;
